import React from 'react'
import { Link } from 'react-router-dom'

const PrivacyPolicy = () => {
    return (
        <>
            <section className="inner-banner">
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-6" data-aos="fade-right" data-aos-duration={1000}>
                            <div className="inner-banner-left">
                                <h1>Privacy Policy</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="inner-banner-right">
                                <img src="images/hero-tires.png" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
                <h2>Tyres</h2>
            </section>
            <section className='website_policy_sec'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <h2>1. Introduction</h2>
                            <p>Your privacy is important to us. This Privacy Policy explains how MV Tyres collects, uses, and protects your personal information when you use our website or services.</p>
                            <h2>2. Information We Collect</h2>
                            <p>We may collect the following information:</p>
                            <ul>
                                <li>Name, phone number, and email address</li>
                                <li>Billing and delivery addresses</li>
                                <li>Vehicle details (for tyre fitting purposes)</li>
                                <li>Payment information (processed securely via third-party providers)</li>
                                <li>Website usage data through cookies (see below)</li>
                            </ul>
                            <h2>3. How We Use Your Information</h2>
                            <p> We use your information to:</p>
                            <ul>
                                <li>Process orders and bookings</li>
                                <li>Communicate with you about your services</li>
                                <li>Improve our website and customer experience</li>
                                <li>Send promotional offers (only if you have opted in)</li>
                            </ul>
                            <h2>4. Sharing Your Information</h2>
                            <p> We do not sell or rent your personal information to third parties. We may share limited information with trusted partners (e.g., payment processors, delivery providers) where necessary to complete your order.</p>
                            <h2>5. Cookies</h2>
                            <p> Our website uses cookies to improve functionality and track visitor behaviour. You can disable cookies in your browser settings, but some features may not work correctly.</p>
                            <h2>6. Data Security</h2>
                            <p> We take appropriate technical and organisational measures to protect your data against loss, misuse, or unauthorised access.</p>
                            <h2>7. Your Rights</h2>
                            <p> You have the right to request a copy of the personal data we hold about you, ask us to correct inaccuracies, or request deletion of your data where legally permitted.</p>
                            <h2>8. Changes to This Policy</h2>
                            <p> We may update this Privacy Policy from time to time. Changes will be posted on this page.</p>
                            <h2>9. Contact Us</h2>
                            <p> If you have questions about our Terms or Privacy Policy, please contact us at:</p>
                            <p><Link to="mailto:info@domain.com">info@domain.com</Link></p>
                            <p><Link to="tel:(760) 433-3600">(760) 433-3600</Link></p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PrivacyPolicy